// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legal .content * {\n  margin-bottom: 20px;\n}\n.legal .content h1 {\n  font-size: 36px;\n  font-weight: 600;\n}\n.legal .content h2,\n.legal .content h3 {\n  font-size: 32px;\n  font-weight: 600;\n}\n.legal .content li {\n  list-style: disc;\n  margin-left: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
